'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('403', {
    templateUrl: '/views/errors/403.html',
    controller: function() {},
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set('Access Denied - Opencare');
      },
    },
    data: {
      hideNavigation: true,
    },
  });
});
